import CheckboxSelectAllController from './checkbox_select_all_controller';

export default class EmailNotificationPreferenceSelectAllController extends CheckboxSelectAllController {}
